// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","CategoriesList":"bj_a big_ea big_ke big_ju big_wl"};